import React, { Component } from "react";
import {Link} from "react-router-dom";
import { FiChevronDown } from 'react-icons/fi';
import axios from 'axios';
import InfiniteScroll from 'react-infinite-scroll-component';

import './Orders.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';
import { generateAndShareBrowserPdf } from '../../assets/js/browserPdf.js';

class Order extends Component {
  url = `${process.env.REACT_APP_SSS}`;

  constructor(props) {
    super(props);
    this.state = {
      req_salesorders : [],
      pend_salesorders : [],
      so_confirmed_salesorders : [],
      placed_salesorders : [],
      salesorder_id : '',
      so_reject_reason : '',
      so_reorder_reason : '',
      attachment : ''
    }
    this.formChange = this.formChange.bind(this);
    this.rejectFormSubmit = this.rejectFormSubmit.bind(this);
    this.reorderFormSubmit = this.reorderFormSubmit.bind(this);
    this.uploadFormSubmit = this.uploadFormSubmit.bind(this);
    this.fetchSoData = this.fetchSoData.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.pdfGenerate = this.pdfGenerate.bind(this);
    this.savePDF = this.savePDF.bind(this);
    this.sharePDF = this.sharePDF.bind(this);
    this.b64toBlob = this.b64toBlob.bind(this);

  }

  componentDidMount(){    
    
    var obj_this = this;

    obj_this.fetchSoData();

    $(".sales_orders_page_container").on("click",".so_approve_button",function(e){
      e.stopPropagation();
      if(!confirm("Do you want to confirm this order")){
        return;
      }
      // var so_approval = obj_this.context.user_details.so_approval;
      const salesorder_id = $(this).attr("salesorder_id");
      const reporting_to = $(this).attr("reporting_to");
      // if(reporting_to){
      //   so_approval = "";
      // }
      const url = `${process.env.REACT_APP_SSS}/api/salesorderApproval`;
      obj_this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          reporting_to : reporting_to,
          salesorder_id : salesorder_id
        },
        type : "POST"
      }).done(function(return_data){
          console.log(return_data);
        if(return_data.status == "success"){
          obj_this.setState(return_data.salesorders,()=>{
            $(".sales_orders_page_container .single_so_container").css("height","60px").find(".arrow_down").css("transform","rotate(0deg)");
          });
          obj_this.context.loading(0);
          alert("Salesorder verified.")
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });

    });

    $(".sales_orders_page_container").on("click",".so_edit_button",function(e){
       e.stopPropagation();
       const salesorder_id = $(this).attr("salesorder_id");
       obj_this.props.history.push("/salesorders/edit/"+salesorder_id);
    });

    $(".sales_orders_page_container").on("click",".single_so_container",function(){
      if($(this).outerHeight() == "60"){
        $(this).heightAuto();
        $(this).find(".arrow_down").css("transform","rotate(180deg)");
      }else{
        $(this).css("height","60px");
        $(this).find(".arrow_down").css("transform","rotate(0deg)");
      }
    });

    $(".sales_orders_page_container").on("click",".asm_reject_button",function(e){
      e.stopPropagation();
      obj_this.setState({
        salesorder_id : $(this).attr("salesorder_id")
      });
      $(".close_form_ghost").css("display","block");

    });

    $(".sales_orders_page_container").on("click",".draft_reject_button",function(e){
      e.stopPropagation();

      if(!confirm("Do you want to delete this order")){
        return;
      }

      const salesorder_id = $(this).attr("salesorder_id");
    
      console.log(this.state);
      const url = `${process.env.REACT_APP_SSS}/api/salesorderDraftRejection`;
      obj_this.context.loading(1);
      const so_reject_reason = obj_this.state.so_reject_reason;
      $(".close_form_ghost").css("display","none");
      obj_this.setState({
        so_reject_reason : ""
      });
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          salesorder_id : salesorder_id
        },
        type : "POST"
      }).done(function(return_data){
          console.log(return_data);
        if(return_data.status == "success"){

          obj_this.fetchSoData();
          obj_this.context.loading(0);
          alert("Salesorder Deleted")

        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
       }).fail(function(){
        alert("Network error");
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      });

    });

    $(".close_button").on("click",function(){
      $(".close_form_ghost, .reorder_form_ghost, .file_upload_form_ghost").css("display","none");
      obj_this.setState({
        so_reject_reason : "",
        so_reorder_reason : ""
      });
    });

    $(".sales_orders_page_container").on("click",".so_reorder_button",function(e){
      e.stopPropagation();
      if(!confirm("Do you want to reorder this order")){
        return;
      }
      obj_this.setState({
        salesorder_id : $(this).attr("salesorder_id")
      });
      $(".reorder_form_ghost").css("display","block");

    });

    $(".sales_orders_page_container").on("click",".asm_upload_button",function(e){
      e.stopPropagation();

      obj_this.setState({
        salesorder_id : $(this).attr("salesorder_id")
      });
      $(".file_upload_form_ghost").css("display","block");

    });

    // Native listener required here because swipeMenu intercepts React synthetic events
    $(".sales_orders_page_container").on("click",".asm_download_button",function(e){
      e.stopPropagation();
      var src = $(this).attr("id"); // Using the ID attribute which holds the attachment_src
      if (src && !src.startsWith('/')) {
        src = '/' + src;
      }
      var apk_url = obj_this.url + src;
      const cb = new Date().getTime();
      const finalUrl = apk_url.includes('?') ? `${apk_url}&cb=${cb}` : `${apk_url}?cb=${cb}`;
      console.log("Native Download Click: ", finalUrl);
      
      if (typeof window !== 'undefined' && window.cordova && typeof cordova !== 'undefined' && cordova.InAppBrowser) {
        cordova.InAppBrowser.open(finalUrl, '_system');
      } else {
        var encoded_url = encodeURI(finalUrl);
        var a = document.createElement('a');
        a.href = encoded_url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    });

    ui.swipeMenu(".sales_orders_container");

   
   
  }

  fetchSoData(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getExeSalesorders`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){ 
        obj_this.setState(return_data.salesorders);
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });

  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  rejectFormSubmit(e){
    e.preventDefault();
    console.log(this.state);
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/salesorderRejection`;
    obj_this.context.loading(1);
    const so_reject_reason = obj_this.state.so_reject_reason;
    $(".close_form_ghost").css("display","none");
    obj_this.setState({
      so_reject_reason : ""
    });
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
        so_reject_reason : so_reject_reason,
        salesorder_id : obj_this.state.salesorder_id
      },
      type : "POST"
    }).done(function(return_data){
        console.log(return_data);
      if(return_data.status == "success"){

        obj_this.setState(return_data.salesorders,()=>{
          $(".sales_orders_page_container .single_so_container").css("height","60px").find(".arrow_down").css("transform","rotate(0deg)");
        });
        obj_this.context.loading(0);
        alert("Salesorder rejected.")
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });

  }

  reorderFormSubmit(e){
    e.preventDefault();
    console.log(this.state);
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/salesorderCancelAndReorder`;
    obj_this.context.loading(1);
    const so_reorder_reason = obj_this.state.so_reorder_reason;
    $(".reorder_form_ghost").css("display","none");
    obj_this.setState({
      so_reorder_reason : ""
    });
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
        so_reorder_reason : so_reorder_reason,
        salesorder_id : obj_this.state.salesorder_id
      },
      type : "POST"
    }).done(function(return_data){
        // console.log(return_data);
      if(return_data.status == "success"){

        obj_this.setState(return_data.salesorders,()=>{
          $(".sales_orders_page_container .single_so_container").css("height","60px").find(".arrow_down").css("transform","rotate(0deg)");
        });
        obj_this.context.loading(0);
        alert("Salesorder cancelled and reordered.")
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });

  }
  uploadFormSubmit(e){
    e.preventDefault();
    console.log(this.state);
    var obj_this = this;
    var fd = new FormData(document.querySelector('.upload_form'));
    fd.append('attachment', obj_this.state.attachment)
    fd.append('salesorder_id',obj_this.state.salesorder_id);
    fd.append('sid',obj_this.context.user_details.sid);

    const url = `${process.env.REACT_APP_SSS}/api/salesorder/upload/file`;
    obj_this.context.loading(1);
    $(".file_upload_form_ghost").css("display","none");

    axios.post(url,fd)
    .then(res =>{
      console.log(res.data);
      if(res.data.status == "success"){
        obj_this.setState(res.data.salesorders,()=>{
          $(".sales_orders_page_container .single_so_container").css("height","60px").find(".arrow_down").css("transform","rotate(0deg)");
        });
        alert("File Uploaded Successfully.");
        obj_this.context.loading(0);
      }
      else {
        alert("Network Error.");
        obj_this.context.loading(0);
      }
    });
  }
  uploadFile = (e) => {
    this.setState({
        attachment: e.target.files[0]
    })
}
deleteFile(e){
  e.preventDefault();
  console.log(e.target,e.target.attributes.salesorder_id);
  // return
  if(!confirm("Do you want to delete?")){
    return
  }
  var obj_this = this;
  var fd = new FormData();
  fd.append('salesorder_id',e.target?.attributes?.salesorder_id?.value??"null");
  fd.append('sid',obj_this.context.user_details.sid);

  const url = `${process.env.REACT_APP_SSS}/api/salesorder/delete/file`;
  obj_this.context.loading(1);

  axios.post(url,fd)
  .then(res =>{
    console.log(res.data);
    if(res.data.status == "deleted"){
      obj_this.setState(res.data.salesorders,()=>{
        $(".sales_orders_page_container .single_so_container").css("height","60px").find(".arrow_down").css("transform","rotate(0deg)");
      });
      alert("File Deleted Successfully.");
      obj_this.fetchSoData();
      obj_this.context.loading(0);
    }
    else if(res.data.status == "no_image") {
      alert("No image to delete");
      obj_this.context.loading(0);
    }else{
      alert("Network Error");
      obj_this.context.loading(0);
    }
  });

}
savePDF(base64Data, fileName) {
  var blob = this.b64toBlob(base64Data, 'application/pdf');
  var blobUrl = URL.createObjectURL(blob);
  console.log('Documents Directory URL:', cordova.file.dataDirectory);
  var self = this; // Store a reference to 'this'

  document.addEventListener('deviceready', function () {
      window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (dirEntry) {
          dirEntry.getFile(fileName, { create: true }, function (fileEntry) {
              fileEntry.createWriter(function (fileWriter) {
                  fileWriter.onwriteend = function () {
                      console.log("Successful file write:", fileName);
                      // Read the file after writing (if needed)
                      self.sharePDF(fileEntry.toURL(), 'application/pdf');
                  };

                  fileWriter.onerror = function (e) {
                      console.log("Failed file write:", e.toString());
                  };

                  fileWriter.write(blob); // Write the Blob to the file
              }, function (err) {
                  console.error('Error creating file writer:', err);
              });
          }, function (err) {
              console.error('Error getting file:', err);
          });
      }, function (err) {
          console.error('Error resolving file system URL:', err);
      });
  });
}

sharePDF(fileUrl, mimeType) {
  window.plugins.socialsharing.share(null, null, fileUrl, null, function (err) {
    console.error('Error sharing PDF:', err);
  }, {
      subject: 'Share PDF', // Subject for the sharing action
      mimeType: mimeType // Specify the MIME type of the file being shared
  });
}




b64toBlob(b64Data, contentType) {
  contentType = contentType || '';
  var sliceSize = 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}
pdfGenerate(e){
  const salesorder_id =  e.currentTarget.getAttribute('salesorder_id');
  var obj_this = this;
  obj_this.context.loading(1);
  const url = `${process.env.REACT_APP_SSS}/api/fetchPendingSalesorder`;

  $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
        salesorder_id : salesorder_id
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        var state_object = return_data.state_object;
        console.log(state_object);
        // return
        
        // obj_this.setState(state_object,() => {
        //   $(".minimize_button").trigger("click");
        // });
        let options = {
          documentSize: 'A4',
          type: "share",
          fileName: state_object.customer.label+'-'+salesorder_id+'.pdf'
        }
        var order_date= new Date(epochToDate(state_object.order_date)).toLocaleDateString('en-GB');
        var delivery_date= new Date(epochToDate(state_object.delivery_date)).toLocaleDateString('en-GB');


        var text = '<html><head><style>table, td, th {border: 1px solid;align:right;padding:10px 2px;font-size:10px}table {width: 100%;border-collapse: collapse;}td{align:center}</style><head><h4 align="center"><b><u>ESTIMATE</u></b></h4><br><br><span>Customer : <b>'+state_object.customer.label+'</b></span><br>'
        // +' GST: <span><b>'+state_object.customer.gst+'</b></span> <br>'
        +' Address: <span>'+state_object.billing_address+'</span> <br>'
        +' Contact No: <span>'+state_object.billing_contact_no??''+'</span> <br>'
        +' Order Date: <span>'+order_date+'</span> <br/>'
        +' Delivery Date: <span>'+delivery_date+'</span> <br/><br/><br/>';

        text=text + '<table><tr><th>Sl No.</th><th>Product Name</th><th>Qty</th><th>Unit</th><th>Unit Price</th><th>Amount</th><th>Total</th></tr><tbody>';
        
        for(var i=0;i<state_object.rows.length;i++){
      
          text = text + '<tr><td align="center">'+ [i+1] +'</td>';
          text = text + '<td align="left">'+state_object.rows[i].product['label']+'</td>';
          text = text + '<td align="right">'+state_object.rows[i].qty+'</td>';
          text = text + '<td align="center">'+state_object.rows[i].unit.label+'</td>';
          text = text + '<td align="right">'+parseFloat(state_object.rows[i].unit_price).toFixed(3)+'</td>';
          text = text + '<td align="right">'+parseFloat(state_object.rows[i].total).toFixed(3)+'</td>';
          text = text + '<td align="right">'+parseFloat(state_object.rows[i].sub_total).toFixed(3)+'</td></tr>';

      
        }
        // var grand_total = parseFloat(state_object.rows.reduce((total_amount, product) => total_amount + parseFloat(product.total_amount), 0)).toFixed(2);
        // alert(grand_total);
      
        // var final_total = Math.round(grand_total).toFixed(2);
        // var round_off = parseFloat(final_total - grand_total).toFixed(2);
        text = text + ' <tr><th colSpan="6" align="right">Total </th><th align="right">'+state_object.sub_total+'</th></tr>';
        text = text + ' <tr><th colSpan="6" align="right">Round Off </th><th align="right">'+state_object.roundoff+'</th></tr>';
        text = text + ' <tr><th colSpan="6" align="right">Grand Total </th><th align="right">'+state_object.grand_total+'</th></tr>';
        text=text + '</tbody></table>';
        
        if (typeof window !== 'undefined' && window.cordova && typeof pdf !== 'undefined') {
          pdf.fromData(text, options)
          .then(()=>{
            // Native sharing handles saving
          })  
          .catch((err)=>console.log(err));
        } else {
          generateAndShareBrowserPdf(text, options.fileName, () => {});
        }
            obj_this.context.loading(0);
          }else{
            obj_this.context.loading(0);
            obj_this.props.history.replace("/");
          }
        }).fail(function(){
          obj_this.context.loading(0);
          alert("Network error");
        });
}
  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="sales_orders_page_container noselect">
          <div className="header_spacer"></div>
          <div className="sales_orders_container uijs swipemenu">
            <div className="page_header">
              <div className="page_title">Salesorder List</div>
              <Link className="new_sales_order_button" 
                to="/salesorders/new"
                style={{visibility:this.context.user_details.place_order==1?"visible":"hidden"}}
              > <i className="fa fa-plus plus_icon"></i> New</Link>
            </div>

            <div className="toggles_container">
              <div className="list_1 toggles" menu="0">
                <i className="fa fa-clipboard-list order_status_icon"></i>
                <div className="order_status">Requested</div>
                <div className="order_count">{this.state.req_salesorders.length}</div>
              </div>
              <div className="list_2 toggles" menu="1">
                <i className="fa fa-hourglass-start order_status_icon"></i>
                <div className="order_status">Pending</div>
                <div className="order_count">{this.state.pend_salesorders.length}</div>
              </div>
              <div className="list_3 toggles" menu="2">
                <i className="fa fa-box order_status_icon"></i>
                <div className="order_status">SO Confirmed</div>
                <div className="order_count">{this.state.so_confirmed_salesorders.length}</div>
              </div>
              <div className="list_4 toggles" menu="3">
                <i className="fa fa-check-circle order_status_icon"></i>
                <div className="order_status">Placed</div>
                <div className="order_count">{this.state.placed_salesorders.length}</div>
              </div>
            </div>
           
            <div className="list_blocks_container">
              <div className="lists_container">
                <InfiniteScroll
                  dataLength={ this.state.req_salesorders.length }
                  refreshFunction={this.fetchSoData}
                  pullDownToRefresh
                  pullDownToRefreshThreshold={200}
                  pullDownToRefreshContent={
                    <h3 style={{ textAlign: 'center' , top : '50px'}}>&#8595; Pull down to refresh</h3>
                  }
                  releaseToRefreshContent={
                    <div className="loading_container" style={{ textAlign: 'center' , top : '100px'}} >
                      <div className="loading_symbol">
                        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                        width="40px" height="40px" viewBox="0 0 50 50" style={{enableBackground:'new 0 0 50 50'}}>
                          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                             {/*<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.5s" repeatCount="indefinite"/>*/}
                          </path>
                        </svg>
                      </div>
                    </div>
                  }
                  >
               
                  {this.state.req_salesorders.map((item,idx)=>(
                    <div className="single_so_container" key={idx}>
                      <div className="so_details_container">
                        <div>
                          <div className="so_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                          {/* <div className="so_distributor_name"><i className="fa fa-industry"></i> {item.distributor_name}</div> */}
                          <div className="so_order_date">Order date : {item.order_date}</div>
                          <div className="so_delivery_date">Delivery date : {item.delivery_date}</div>
                          <br></br>
                          <div className="so_executive_name"
                          style={{display:item.exe_name?"block":"none"}}>
                          <i className="fas fa-user"></i>{item.exe_name}</div>
                        </div>
                        
                        <div className="so_approve_button_so_no"
                          style={{visibility:item.id?"visible":"hidden"}}
                        >
                          <i className="fas fa-hashtag"></i>{item.so_no}
                        </div>
                        {/* <div className="so_activity_container" style={{ visibility: this.context.user_details.staff_id == item.marketing_exe_id ? 'visible' : 'hidden' }}>
                          <div className="asm_pdf_button"
                            salesorder_id={item.id}
                            onClick={this.pdfGenerate}
                          >
                            <i className="fa fa-share-alt"></i>PDF
                          </div>
                        </div> */}
                        {/* <div className="so_reorder_button"
                          salesorder_id = {item.id}
                          style={{visibility:this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"visible":"hidden"}}
                        >
                          <i className="fas fa-history"></i>
                        </div>
                        <div className="so_approve_button"
                          salesorder_id = {item.id}
                          reporting_to = {this.context.user_details.staff_id == item.reporting_to?1:0}
                          style={{visibility:this.context.user_details.place_order && this.context.user_details.staff_id == item.marketing_exe_id || this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"visible":"hidden"}}
                        >
                          <i className="fas fa-check"></i>
                        </div>
                        <div className="so_edit_button" 
                          salesorder_id={item.id}
                          style={{display:this.context.user_details.place_order && this.context.user_details.staff_id == item.marketing_exe_id?"block":"none"}}
                        >
                          <i className="fa fa-pencil-alt"></i>
                        </div>
                        <div className="asm_reject_button"
                          salesorder_id = {item.id}
                          style={{display:this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"block":"none"}}
                        >
                          <i className="fas fa-times"></i>
                        </div>
                        <div className="asm_upload_button"
                          salesorder_id = {item.id}
                          style={{visibility:this.context.user_details.place_order && this.context.user_details.staff_id == item.marketing_exe_id || this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"visible":"hidden"}}
                        >
                          <i className="fas fa-file-upload"></i> 
                        </div> */}
                        <div className="so_products_button">
                          <FiChevronDown className="arrow_down" />
                        </div>
                      </div>
                      <div className="remarks_style" style={{display:item.remarks?"grid":"none"}}>
                        <span>Remarks :&nbsp;</span>
                        <span>{item.remarks}</span>
                      </div>
                      <br></br>
                      <table className={`so_products_container ${context.magnified ? 'app-magnified-table' : ''}`} style={{display:item.products.length?"table":"none"}}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th >Qty</th>
                            <th>Unit</th>
                            <th align="center">UP</th>
                            <th align="center">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                        {item.products.map((product,index) => (
                          <tr key={index}>
                            <td valign="top">{index+1}</td>
                            <td valign="top">{product.product_specification == null || product.product_specification == ""?product.name:product.name+"/"+product.product_specification }</td>
                            <td valign="top" align="center">{product.qty}</td>
                            <td valign="top">{product.unit}</td>
                            <td valign="top" align="right">{parseFloat(product.total/product.qty).toFixed(3)}</td>
                            <td align="right" valign="top">{product.total}</td>
                          </tr>
                        ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="2" align="right"></th>
                            <th align="center">{parseFloat(item.products.reduce((qty, product) => qty + parseFloat(product.qty), 0)).toFixed(3)}</th>
                            <th colSpan="2" align="right">Total :  {this.context.currency}</th>
                            <th align="right">{parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)}</th>
                          </tr>
                          {/*<tr style={{display:item.tax?"table-row":"none"}}>
                            <th colSpan="5" align="right">Tax : </th>
                            <th align="right">{item.tax}</th>
                          </tr>
                          <tr style={{display:item.grand_total?"table-row":"none",fontSize : "12px",color : "#ea8000"}}>
                            <th colSpan="5" align="right">Grand Total ({this.context.currency}) :</th>
                            <th align="right">{item.grand_total}</th>
                          </tr>*/}
                        </tfoot>
                      </table>
                      <div className="so_activity_container">
                        
                        <div className="so_reorder_button"
                          salesorder_id = {item.id}
                          style={{display:this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"block":"none"}}
                        >
                          <i className="fas fa-history"></i>
                        </div>
                        <div className="so_approve_button"
                          salesorder_id = {item.id}
                          reporting_to = {this.context.user_details.staff_id == item.reporting_to?1:0}
                          style={{display: this.context.user_details.staff_id == item.marketing_exe_id || this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"block":"none"}}
                        >
                          <i className="fas fa-check"></i>
                        </div>
                        <div className="so_edit_button" 
                          salesorder_id={item.id}
                          style={{display: this.context.user_details.staff_id == item.marketing_exe_id ?"block":"none"}}
                        >
                          <i className="fa fa-pencil-alt"></i>
                        </div>
                        <div className="asm_reject_button"
                          salesorder_id = {item.id}
                          style={{display:this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"block":"none"}}
                        >
                          <i className="fas fa-times"></i>
                        </div>
                        <div className="draft_reject_button"
                          salesorder_id = {item.id}
                          style={{display:this.context.user_details.staff_id == item.marketing_exe_id?"block":"none"}}
                        >
                          <i className="fas fa-times"></i>
                        </div>
                        <div className="file_actions_group" style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                          <span style={{ fontSize: "12px", color: "var(--text-secondary)", fontWeight: "600" }}>File:</span>
                          <div className="asm_upload_button"
                            salesorder_id = {item.id}
                            style={{display: this.context.user_details.staff_id == item.marketing_exe_id || this.context.user_details.so_approval && this.context.user_details.staff_id == item.reporting_to?"block":"none"}}
                          >
                            <i className="fas fa-file-upload"></i> 
                          </div>

                          <div className="asm_download_button"
                            id={item.attachment_src}
                            style={{display:item.attachment_src != null ?"block":"none"}}
                          >
                            <i className="fa fa-file"></i>
                          </div>

                          {/* <div className="asm_image_delete_button"
                            salesorder_id = {item.id}
                            style={{display:item.attachment_src != null ?"block":"none"}}
                            onClick={this.deleteFile}
                          >
                            <i className="fa fa-trash"></i>
                          </div> */}
                        </div>
                        <div className="asm_pdf_button"
                          salesorder_id={item.id}
                          onClick={this.pdfGenerate}
                        >
                          <i className="fa fa-share-alt"></i>PDF
                        </div>
                        
                      </div>
                    
                    </div>
                  ))}
                </InfiniteScroll>
              </div>
              <div className="lists_container">
                {this.state.pend_salesorders.map((item,idx)=>(
                  <div className="single_so_container" key={idx}
                    style={{backgroundColor:item.status == "HOLD"?"rgba(255, 255, 0, 0.31)":item.status == "SOCANCEL"?"rgba(255, 0, 0, 0.26)":item.status == "APR"?"rgba(255, 0, 0, 0.04)":"",
                            color:item.status ==  "APR"?"rgba(255, 0, 36, .96)":""
                  }}
                  >
                    <div className="so_details_container">
                      <div>
                        <div className="so_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        {/* <div className="so_distributor_name"><i className="fa fa-industry"></i> {item.distributor_name}</div> */}
                        <div className="so_order_date">Order date : {item.order_date}</div>
                        <div className="so_delivery_date">Delivery date : {item.delivery_date}</div>
                        <br></br>
                                              
                      </div>
                      <div>
                      <div className="so_status">{item.status ==  "APR"? 'ESCALATED':''}</div>
                      <div className="so_approve_button_so_no"
                        style={{visibility:item.id?"visible":"hidden"}} >
                         <i className="fas fa-hashtag"></i>{item.so_no}
                      </div>
                      </div>
                    
                      <div></div>
                      <div></div>
                      
                      <div className="so_products_button">
                        <FiChevronDown className="arrow_down" />
                      </div>
                    </div>
                    {item.status ==  "MCNF"?
                    <div className="so_executive_name">
                    Waiting for ASM Approval
                    </div>:<div className="so_executive_name">
                    Waiting for SO Level One
                    </div>}
                    <div className="so_executive_name"
                        style={{display:item.exe_name?"block":"none",margin:"12px 0px"}}>
                         <i className="fas fa-user"></i> {item.exe_name}
                         <span style={{visibility:this.context.user_details.global_so_access && item.reporting_to_person?"visible":"hidden"}}> - Reporting to - {item.reporting_to_person}
                         </span>
                    </div>
                    <div className="remarks_style" style={{display:item.remarks?"grid":"none"}}>
                      <span>Remarks :&nbsp;</span>
                      <span>{item.remarks}</span>
                    </div>
                    <br></br>
                    <table className={`so_products_container ${context.magnified ? 'app-magnified-table' : ''}`} style={{display:item.products.length?"table":"none"}}>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Qty</th>
                          <th>Unit</th>
                          <th align="center">Unit Price</th>
                          <th align="center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                      {item.products.map((product,index) => (
                        <tr key={index}>
                          <td valign="top">{index+1}</td>
                          <td valign="top">{product.product_specification == null || product.product_specification == ""?product.name:product.name+"/"+product.product_specification}</td>
                          <td valign="top">{product.qty}</td>
                          <td valign="top">{product.unit}</td>
                          <td valign="top" align="right">{parseFloat(product.total/product.qty).toFixed(3)}</td>
                          <td align="right" valign="top">{product.total}</td>
                        </tr>
                      ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan="2" align="right"></th>
                          <th align="right">{parseFloat(item.products.reduce((qty, product) => qty + parseFloat(product.qty), 0)).toFixed(3)}</th>
                          <th colSpan="2" align="right">Total :  {this.context.currency}</th>
                          <th align="right">{parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)}</th>
                        </tr>
                        {/*<tr style={{display:item.tax?"table-row":"none"}}>
                          <th colSpan="5" align="right">Tax : </th>
                          <th align="right">{item.tax}</th>
                        </tr>
                        <tr style={{display:item.grand_total?"table-row":"none",fontSize : "12px",color : "#ea8000"}}>
                          <th colSpan="5" align="right">Grand Total ({this.context.currency}) :</th>
                          <th align="right">{item.grand_total}</th>
                        </tr>*/}
                      </tfoot>
                    </table>
                    <div className="so_activity_container" style={{visibility:this.context.user_details.staff_id == item.marketing_exe_id ?'visible':'hidden'}}>
                      <div className="asm_pdf_button"
                        salesorder_id = {item.id}
                        onClick = {this.pdfGenerate}
                      >
                        <i className="fa fa-share-alt"></i>PDF
                      </div>  
                    </div>
                    <div className="so_executive_name" style={{display:(item.status=='CNF' && this.context.user_details.global_so_access=='1' )?'block':'none'}}>Waiting for Collection Approval</div>

                  </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.so_confirmed_salesorders.map((item,idx)=>(
                  <div className="single_so_container" key={idx}>
                    <div className="so_details_container">
                      <div>
                        <div className="so_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        {/* <div className="so_distributor_name"><i className="fa fa-industry"></i> {item.distributor_name}</div> */}
                        <div className="so_order_date">Order date : {item.order_date}</div>
                        <div className="so_delivery_date">Delivery date : {item.delivery_date}</div>
                        <br></br>
                        <div className="so_executive_name"
                        style={{display:item.exe_name?"block":"none"}}>
                         <i className="fas fa-user"></i>{item.exe_name}</div>
                      </div>
                      <div className="so_approve_button_so_no"
                        style={{visibility:item.id?"visible":"hidden"}}
                      >
                         <i className="fas fa-hashtag"></i>{item.so_no}
                      </div>
                      <div></div>
                      <div></div>
                      
                      <div className="so_products_button">
                        <FiChevronDown className="arrow_down" />
                      </div>
                    </div>
                    <div className="remarks_style" style={{display:item.remarks?"grid":"none"}}>
                        <span>Remarks :&nbsp;</span>
                        <span>{item.remarks}</span>
                    </div>
                    <br></br>
                    <table className={`so_products_container ${context.magnified ? 'app-magnified-table' : ''}`} style={{display:item.products.length?"table":"none"}}>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Qty</th>
                          <th>Unit</th>
                          <th align="center">Unit Price</th>
                          <th align="center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                      {item.products.map((product,index) => (
                        <tr key={index}>
                          <td valign="top">{index+1}</td>
                          <td valign="top">{product.product_specification == null || product.product_specification == ""?product.name:product.name+"/"+product.product_specification }</td>
                          <td valign="top">{product.qty}</td>
                          <td valign="top">{product.unit}</td>
                          <td valign="top" align="right">{parseFloat(product.total/product.qty).toFixed(3)}</td>
                          <td align="right" valign="top">{product.total}</td>
                        </tr>
                      ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan="2" align="right"></th>
                          <th align="right">{parseFloat(item.products.reduce((qty, product) => qty + parseFloat(product.qty), 0)).toFixed(3)}</th>
                          <th colSpan="2" align="right">Total :  {this.context.currency}</th>
                          <th align="right">{parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)}</th>
                        </tr>
                        {/* <tr style={{display:item.tax?"table-row":"none"}}>
                          <th colSpan="5" align="right">Tax : </th>
                          <th align="right">{item.tax}</th>
                        </tr> */}
                        <tr style={{display:item.grand_total?"table-row":"none",fontSize : "12px",color : "#ea8000"}}>
                          <th colSpan="5" align="right">Grand Total ({this.context.currency}) :</th>
                          <th align="right">{item.grand_total}</th>
                        </tr>
                      </tfoot>
                    </table>

                  </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.placed_salesorders.map((item,idx)=>(
                  <div className="single_so_container" key={idx}>
                    <div className="so_details_container">
                      <div>
                        <div className="so_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        {/* <div className="so_distributor_name"><i className="fa fa-industry"></i> {item.distributor_name}</div> */}
                        <div className="so_order_date">Order date : {item.order_date}</div>
                        <div className="so_delivery_date">Delivery date : {item.delivery_date}</div>
                        <br></br>
                        <div className="so_executive_name"
                        style={{display:item.exe_name?"block":"none"}}>
                         <i className="fas fa-user"></i>{item.exe_name}</div>
                      </div>
                      <div className="so_approve_button_so_no"
                        style={{visibility:item.id?"visible":"hidden"}}
                      >
                         <i className="fas fa-hashtag"></i>{item.so_no}
                         {item.trip_details?
                         <div className="trip_no">
                          {/* <span style={{visibility:item.trip_details?"visible":"hidden"}}><i class="fa fa-truck" aria-hidden="true"></i>{item.trip_details?item.trip_details['trip_no']:''}</span><br></br> */}
                          <span style={{visibility:item.trip_details?"visible":"hidden"}}><i class="fa fa-phone-alt" ></i><a style={{color: "inherit",textDecoration: "none"}}href={"tel:"+item.trip_details['driver_no']}>{item.trip_details?item.trip_details['driver_no']:''}</a></span><br></br>
                          <span style={{visibility:item.trip_details?"visible":"hidden"}}><i class="fa fa-id-card" aria-hidden="true"></i>{item.trip_details?item.trip_details['vehicle_no']:''}</span>
                         </div>
                         :undefined}

                      </div>
                      
                      <div className="so_products_button">
                        <FiChevronDown className="arrow_down" />
                      </div>
                    </div>
                    <div className="remarks_style" style={{display:item.remarks?"grid":"none"}}>
                        <span>Remarks :&nbsp;</span>
                        <span>{item.remarks}</span>
                      </div>
                    <br></br>
                    <table className={`so_products_container ${context.magnified ? 'app-magnified-table' : ''}`} style={{display:item.products.length?"table":"none"}}>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Qty</th>
                          <th>Unit</th>
                          <th align="center">Unit Price</th>
                          <th align="center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                      {item.products.map((product,index) => (
                        <tr key={index}>
                          <td valign="top">{index+1}</td>
                          <td valign="top">{product.product_specification == null || product.product_specification == ""?product.name:product.name+"/"+product.product_specification }</td>
                          <td valign="top">{product.qty}</td>
                          <td valign="top">{product.unit}</td>
                          <td valign="top" align="right">{parseFloat(product.total/product.qty).toFixed(3)}</td>
                          <td align="right" valign="top">{product.total}</td>
                        </tr>
                      ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan="2" align="right"></th>
                          <th align="right">{parseFloat(item.products.reduce((qty, product) => qty + parseFloat(product.qty), 0)).toFixed(3)}</th>
                          <th colSpan="2" align="right">Total : {this.context.currency}</th>
                          <th align="right">{parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)}</th>
                        </tr>
                        <tr style={{display:item.grand_total>parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)?"table-row":"none"}}>
                          <th colSpan="5" align="right">Other Charges : {this.context.currency}</th>
                          <th align="right">{parseFloat(item.grand_total-parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)).toFixed(3)}</th>
                        </tr>
                        <tr style={{display:item.grand_total?"table-row":"none",fontSize : "12px",color : "#ea8000"}}>
                          <th colSpan="5" align="right">Grand Total {this.context.currency} :</th>
                          <th align="right">{item.grand_total}</th>
                        </tr>
                      </tfoot>
                    </table>

                  </div>
                ))}
              </div>

            </div>
            <div className="close_form_ghost">
              <form className="close_form" onSubmit={this.rejectFormSubmit} method="post">
                <i className="close_button fas fa-times"></i>
                <div className="input_label">Reason</div>
                <textarea className="custom_input so_reject_reason"
                  name="so_reject_reason"
                  value={this.state.so_reject_reason}
                  onChange={this.formChange}
                  required  
                />
                <button className="confirm_reject_button">CONFIRM</button>
              </form>
            </div>

             <div className="reorder_form_ghost">
              <form className="reorder_form" onSubmit={this.reorderFormSubmit} method="post">
                <i className="close_button fas fa-times"></i>
                <div className="input_label">Reason</div>
                <textarea className="custom_input so_reorder_reason"
                  name="so_reorder_reason"
                  value={this.state.so_reorder_reason}
                  onChange={this.formChange}
                  required  
                />
                <button className="confirm_reorder_button">REORDER</button>
              </form>
            </div>

            <div className="file_upload_form_ghost">
              <form className="upload_form" onSubmit={this.uploadFormSubmit} method="post"encType="multipart/form-data" >
                <i className="close_button fas fa-times"></i>
                <div className="input_label">Upload File</div>
                <input className="file_upload"
                  type="file"
                  name="attachment"
                  id="attachment"
                  onChange={this.uploadFile}
                  autoComplete="off"
                  required
                />
                <button className="confirm_reorder_button">UPLOAD</button>
              </form>
            </div>
            
          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Order;
Order.contextType = MyContext;
